import React from "react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { Button, Col, Form, Input, Row, Upload, Card, Select, Image, message, Modal, Table, Dropdown } from "antd";
import { CameraOutlined, CarOutlined, CloseOutlined, PayCircleOutlined, UploadOutlined } from "@ant-design/icons";
import "./RevenueCollection.css";
import VehicleStore from "../store/VehicleStore";
import config from "../config";
import RevenueCollectionStore from "../store/RevenueCollectionStore";
import dayjs from "dayjs";
import ListTable from "./ListTable";
import axios from "axios";
import { decode as base64_decode } from "base-64";
import Cookies from "universal-cookie";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";

const { Option } = Select;

class RevenueCollection extends React.Component {

    constructor(props, context) {
        super(props);

        this.state = {
            loading: false,
            driverId: null,
            shiftId: null,
            loadData: 0,
            driverPhoto: null,
            driverRevenueData: {},
            receivedCash: null,
            openTripsPopup: false,
            openIsTripVoidPopup: false,
            openChangePaymentTypePopup: false,
            tripVoidProof: null,
            paymentTypeProof: null,
            isTripVoidData: {},
            paymentMethodData: {},
            token: '',
            selectPaymentType: null,
            selectType: null,
            tripUpdateData: {},
            cashToReceive: null,
            disableAccept: true,
            setProofForExpense: [],
            originalCashToReceive: 0,
            cashCollection: 0,
            isShiftOpen: false
        }

        this.revenueCollectionStore = new RevenueCollectionStore()
        this.vehicleStore = new VehicleStore();
        this.formRef = React.createRef();
        this.tripformRef = React.createRef();
        this.paymentformRef = React.createRef();
        this.cookies = new Cookies();

        this.actionColumn = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                            onClick={() => {
                                this.setState({
                                    isTripVoidData: this.state.isTripVoidData,
                                    openIsTripVoidPopup: true,
                                });
                            }}
                        >
                            {" "}
                            {
                                <CarOutlined
                                    style={{ fontSize: "15px", cursor: "pointer" }}

                                />
                            }
                            {"Trip Void"}
                        </div>
                    ),
                    key: "edit",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                            onClick={() =>
                                this.setState({
                                    isTripVoidData: this.state.isTripVoidData,
                                    openChangePaymentTypePopup: true,
                                })
                            }
                        >
                            {" "}
                            <PayCircleOutlined style={{ fontSize: "15px", cursor: "pointer" }}
                            />
                            {context.translate("Payment")}
                        </div>
                    ),
                    key: "assign",
                },
            ],
        };

        this.tripColumns = [
            {
                title: context.translate("_BOOKING_ID_"),
                dataIndex: "bookingId",
                // width: 60,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_VEHICLE_NO_"),
                dataIndex: "vehicleNo",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_DRIVER_NAME_"),
                dataIndex: "driverName",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TRIP_TYPE_"),
                dataIndex: "tripType",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
                render: (value, record) => {
                    if (value === 1) {
                        return "Seat Sensor"
                    } else if (value === 2) {
                        return "Manual"
                    }
                }
            },
            {
                title: context.translate("_SHIFT_NUMBER_"),
                dataIndex: "shiftNo",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TRIP_START_TIME_"),
                dataIndex: "tripStartTime",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TOTAL_FARE_"),
                dataIndex: "totalFare",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_TOTAL_KM_"),
                dataIndex: "hiredDistanceKm",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PAYMENT_TYPE_"),
                dataIndex: "paymentTypeDesc",
                // width: 50,
                ellipsis: {
                    showTitle: true,
                },
            },

            {
                title: context.translate("_ACTION_"),
                dataIndex: "action",
                ellipsis: {
                    showTitle: true,
                },
                render: (value, record) => {
                    if (Number(record.actionType) === 1) {
                        return (
                            <span
                                style={{
                                    color: "red",
                                    fontWeight: 600,
                                }}
                            >
                                Void
                            </span>
                        );
                    }

                    return (
                        <Dropdown
                            menu={this.actionColumn}
                            trigger={["click"]}
                        >
                            <Image
                                style={{ cursor: "pointer" }}
                                src={kebabIcon}
                                preview={false}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ isTripVoidData: record });
                                }}
                            />
                        </Dropdown>
                    );
                },
            }

        ]
    }

    onRevenueDetailsSubmit = async (values) => {
        const data = {
            ...values,
            addedByUserId: this.props.getUserData().userId,
            addedByDateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            taxiId: this.state.driverRevenueData.vehicleId,
            shiftId: this.state.shiftId,
            deductableExpenseProof: this.state.setProofForExpense.join(',')
        }
        const response = await this.revenueCollectionStore.addRevenueData(data)
        if (response.success == "S") {
            message.success(response.message);
            this.formRef.current?.resetFields();

            // Reset state if needed
            this.setState({
                driverId: null,
                driverPhoto: "",
                driverRevenueData: {},
                setProofForExpense: [],
            });

            await this.revenueCollectionStore.setProofForExpense([]);
        } else {
            message.error(response.message);
        }
    }

    async componentDidMount() {
        let tokendata = this.cookies.get("data")
            ? JSON.parse(base64_decode(this.cookies.get("data")))
            : "";
        const userToken = tokendata.userToken;

        this.setState({ token: userToken });
        await this.vehicleStore.getDriversList(
            this.props.getUserData().userCompanyId
            // 44
        );

        this.setState({ loadData: 1 })
    }

    showSelectedDriverInfo = async (driverId) => {
        await this.revenueCollectionStore.getShiftsData(
            driverId
        );
        const selectedDriver = this.vehicleStore?.getDriverName?.find(
            (driver) => driver.driverId === driverId
        );

        if (selectedDriver) {
            this.setState({
                driverId: selectedDriver.driverId,
                driverPhoto: selectedDriver.photo,
            });
        }

    };

    showSelectedShiftInfo = async (shiftId) => {
        // console.log(shiftId, "wertyuioiuyterttrewefgfewefdewsds")
        const revenueData = await this.revenueCollectionStore.getDriverRevenueData(
            shiftId
        );

        if (revenueData.shiftStatus === "OPEN") {
            message.error("Please Closed Shift First")
            this.setState({ disableAccept: true, isShiftOpen: true, })
        } else {
            this.setState({
                isShiftOpen: false,
            });
        }

        const qrCodeData = await this.revenueCollectionStore.getPaymentQRData(shiftId)

        // console.log(qrCodeData, "qrCodeData 308")

        this.setState({ driverRevenueData: revenueData })

        const totalIncomeData = {
            shiftFare: revenueData.shiftFare,
            shiftExtraFare: revenueData.shiftExtraFare
        }

        const totalIncome = this.calculateTotalIncome(totalIncomeData)
        // const totalIncome = revenueData.shiftFare + revenueData.shiftExtraFare

        const cashToReceiveData = {
            collectTotal: revenueData.collectTotal,
            discountCardTotalAmount: revenueData.discountCardTotalAmount,
            shiftCreditCardAmount: revenueData.shiftCreditCardAmount,
        }

        const cashToReceive = this.calculateCashToReceive(cashToReceiveData)

        // console.log(cashToReceive, "cashToReceive")
        this.setState({ cashToReceive: cashToReceive })
        const receivedCashData = {
            cashToReceive: cashToReceive,
            receivedCash: this.state.receivedCash
        }
        const receivedCash = this.calculateReceivedCash(receivedCashData)

        // const cashToReceive = revenueData.collectTotal - revenueData.discountCardTotalAmount - revenueData.shiftCreditCardAmount
        // const receivedCash = cashToReceive - this.state.receivedCash


        const ShiftHiredDistance = revenueData.shiftHiredDistance

        const meterIncome = revenueData.shiftFare - revenueData.shiftExtraFare

        const driverIncome = this.calculateDriverIncome(meterIncome, ShiftHiredDistance)

        // console.log(driverIncome, "driverIncome")
        // console.log(qrCodeData.paymentType, "qrCodeData.paymentType")

        if (revenueData) {
            this.formRef.current.setFieldsValue({
                taxiId: revenueData.vehicleNo,
                shiftNo: revenueData.shiftNo,
                shiftStartTime: revenueData.shiftStartTime,
                shiftEndTime: revenueData.shiftEndTime,
                totalIncome: totalIncome,
                companyIncome: Number(driverIncome.driverIncome).toFixed(2),
                meterIncome: meterIncome,
                bookingCharge: revenueData.shiftExtraFare,
                revenueAdjustment: revenueData.revenueAdjustment,
                pendingAmount: revenueData.pendingAmount,
                driverTips: revenueData.tipsAmount,
                trips: revenueData.tripsQuantity,
                discount: revenueData.discountCardTotalAmount,
                cashToReceive: cashToReceive,
                // cashTobereturned: receivedCash,
                totalKm: revenueData.shiftTotalDistance,
                revenueKm: revenueData.shiftHiredDistance,
                // creditCard: qrCodeData.paymentType === 49 ? qrCodeData.totalFare ?? 0.00 : 0,
                // cashCollection: qrCodeData.paymentType === 48 ? qrCodeData.totalFare ?? 0.00 : 0,
                // qrcodecash: qrCodeData.paymentType === 53 ? qrCodeData.totalFare ?? 0.00 : 0,
                suprchargeFuel: (driverIncome.FuelSurchargeHirdKmTotal).toFixed(2),
                surchargeDriver: (driverIncome.DriverSurchargeHirdKmTotal).toFixed(2),
                surchargeCompany: (driverIncome.ITCSurchargeHirdKmTotal).toFixed(2),
                creditCard: qrCodeData.creditCard ?? 0.00,
                cashCollection: qrCodeData.cash ?? 0.00,
                qrcodecash: qrCodeData.qrCode ?? 0.00,
                // cashCollection: revenueData.collectTotal,
                // creditCard: revenueData.shiftCreditCardAmount,
            })

            // console.log(qrCodeData.cash, "qrCodeData.cash")
            this.setState({
                originalCashToReceive: cashToReceive,
                cashCollection: qrCodeData.cash
            });
        }
    }

    handleDeductableExpenseChange = (e) => {
        const deductableExpense = Number(e.target.value) || 0;

        const updatedCashToReceive = (
            this.state.originalCashToReceive - deductableExpense
        ).toFixed(2);
        console.log(this.state.originalCashToReceive, "this.state.originalCashToReceive")
        console.log(updatedCashToReceive, "updatedCashToReceive")
        this.formRef.current?.setFieldsValue({
            deductableExpense,
            cashToReceive: updatedCashToReceive,
        });
    };

    calculateDriverIncome = (meterFare, ShiftHiredDistance) => {

        // console.log(meterFare, ShiftHiredDistance, "meterFare, ShiftHiredDistance")
        //   double FuelSurchargeHirdKmTotal = ShiftHiredDistance * DEVICE_SETTINGS_FuelSurchargeHirdKmTotal_Percent;
        //   double DriverSurchargeHirdKmTotal = ShiftHiredDistance * DEVICE_SETTINGS_DriverSurchargeHirdKmTotal_Percent;
        //   double ITCSurchargeHirdKmTotal = ShiftHiredDistance * DEVICE_SETTINGS_ITCSurchargeHirdKmTotal_Percent;
        //   double DriverIncome = meterFare - (ITCSurchargeHirdKmTotal + FuelSurchargeHirdKmTotal + DriverSurchargeHirdKmTotal);

        const FuelSurchargeHirdKmTotal = ShiftHiredDistance * 0.005
        const DriverSurchargeHirdKmTotal = ShiftHiredDistance * 0.005
        const ITCSurchargeHirdKmTotal = ShiftHiredDistance * 0.005

        // console.log(FuelSurchargeHirdKmTotal, DriverSurchargeHirdKmTotal, ITCSurchargeHirdKmTotal)

        const driverIncome = meterFare - (ITCSurchargeHirdKmTotal + FuelSurchargeHirdKmTotal + DriverSurchargeHirdKmTotal);

        return {
            driverIncome,
            FuelSurchargeHirdKmTotal,
            DriverSurchargeHirdKmTotal,
            ITCSurchargeHirdKmTotal,
        };
    }

    calculateTotalIncome = (data) => {

        const shiftFare = parseFloat(data.shiftFare) || 0;
        const shiftExtraFare = parseFloat(data.shiftExtraFare) || 0;

        const totalIncome = shiftFare + shiftExtraFare;

        return totalIncome.toFixed(2);
    }

    calculateCashToReceive = (data) => {
        const cashToReceive = data.collectTotal - data.discountCardTotalAmount - data.shiftCreditCardAmount

        return cashToReceive
    }

    calculateReceivedCash = (data) => {
        const receivedCash = data.cashToReceive - data.receivedCash

        return receivedCash
    }

    handleReceivedCashChange = (e) => {
        const value = e.target.value;

        // If input is empty, clear the field
        if (value === "") {
            this.formRef.current?.setFieldsValue({
                cashTobereturned: null, // or ""
            });

            this.setState({
                receivedCash: null,
                disableAccept: true,
            });

            return;
        }

        const receivedCash = Number(value);
        const cashToReceive =
            Number(this.formRef.current?.getFieldValue("cashToReceive")) || 0;


        // const cashTobereturned = receivedCash - cashToReceive;

        const cashTobereturned = (receivedCash - cashToReceive).toFixed(2);


        this.formRef.current?.setFieldsValue({
            cashTobereturned,
        });

        this.setState({
            receivedCash,
            disableAccept: receivedCash < cashToReceive,
        });
    };

    handleTripDetails = async () => {
        this.setState({ openTripsPopup: true })
        await this.revenueCollectionStore.showTripsData(
            {
                // shiftId: this.state.driverRevenueData?.shiftNo,
                shiftId: this.state.shiftId,
                driverId: this.state.driverId
            }
        );
        this.setState({ loadData: 1 })
    }

    uploadTripVoidProof = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("paymentTypeProof", file);
            formData.append("fileType", "userphoto");
            formData.append("fieldName", "paymentTypeProof");

            const response = await axios.post(

                config.NodeUrl + "/cashier/fileUpload",

                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            console.log(error, "eror")
            onError(error);
        }
    };

    getUploadDataForTrip = async (fileUp) => {
        let fileinfo = fileUp.file.response;
        if (fileinfo?.success == "S") {
            await this.setState({ tripVoidProof: fileinfo.data });
        }
        fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
        await this.revenueCollectionStore.setProofForTripVoid(fileUp.fileList);

        this.setState({ update: 1 });
    };

    uploadMultipleProofs = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("setProofForExpense", file);
            formData.append("fileType", "userphoto");
            formData.append("fieldName", "setProofForExpense");

            const response = await axios.post(

                config.NodeUrl + "/cashier/exchangeFileUpload",

                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            console.log(error, "eror")
            onError(error);
        }
    };

    handleRemoveExpenseImage = async (file) => {
        this.setState((prevState) => ({
            setProofForExpense: prevState.setProofForExpense.filter(
                (item) => item !== file.response?.data
            ),
        }));

        const fileList = this.revenueCollectionStore.expensePhotoFromDb.fileList.filter(
            (item) => item.uid !== file.uid
        );

        await this.revenueCollectionStore.setProofForExpense(fileList);
    };


    getUploadMultipleTrip = async (fileUp) => {
        const fileinfo = fileUp.file.response;

        if (fileinfo?.success === "S") {
            this.setState((prevState) => ({
                setProofForExpense: [
                    ...(prevState.setProofForExpense || []),
                    fileinfo.data,
                ],
            }));
        }

        fileUp.file.url = config.fleetURL + fileinfo?.folderName;

        await this.revenueCollectionStore.setProofForExpense(fileUp.fileList);


        this.setState({ update: 1 });
    };

    handleTripUpdateSubmit = async (values) => {
        const data = {
            reason: values.reason,
            tripVoidProof: this.state.tripVoidProof,
            bookingId: this.state.isTripVoidData.bookingId,
            actionType: 1,
            shiftNo: this.state.driverRevenueData?.shiftNo,
            shiftId: this.state.shiftId,
            driverId: this.state.driverId,
            cashToReceive: this.state.cashToReceive,
            cashCollection: this.state.cashCollection
        }
        if (this.state.tripVoidProof) {
            const response = await this.revenueCollectionStore.updateTripsData(data)
            if (response.success == "S") {
                message.success(response.message);
                await this.revenueCollectionStore.setProofForTripVoid([]);
                this.tripformRef.current?.resetFields();
                this.setState({
                    tripVoidProof: null,
                });
                await this.handleTripDetails()
                this.setState({ tripUpdateData: response.data, openIsTripVoidPopup: false, })
                if (response?.data?.actionType === 1) {
                    this.updateDataForTripVoid()
                }
            } else {
                message.error(response.message);
            }
        } else {
            message.error("Proof Is Required");
        }

    }

    handlePaymentTypeSubmit = async (values) => {
        const data = {
            reason: values.reason,
            tripVoidProof: this.state.tripVoidProof,
            bookingId: this.state.isTripVoidData.bookingId,
            actionType: 2,
            paymentType: this.state.selectPaymentType,
            shiftNo: this.state.driverRevenueData?.shiftNo,
            shiftId: this.state.shiftId,
            driverId: this.state.driverId,
            cashToReceive: this.state.cashToReceive,
            cashCollection: this.state.cashCollection
            // actionType: this.state.selectType,
            // shiftId: this.state.driverRevenueData?.shiftNo,
            // driverId: this.state.driverId,
            // cashToReceive: this.state.cashToReceive
        }
        if (this.state.tripVoidProof) {
            const response = await this.revenueCollectionStore.updateTripsData(data)
            if (response.success == "S") {
                message.success(response.message);
                this.paymentformRef.current?.resetFields();
                await this.revenueCollectionStore.setProofForTripVoid([]);
                this.setState({
                    tripVoidProof: null,
                });
                await this.handleTripDetails()
                this.setState({ tripUpdateData: response.data, openChangePaymentTypePopup: false })
                if (response?.data?.actionType === 2) {
                    this.updateDataForTripVoid()
                }
            } else {
                message.error(response.message);
            }
        } else {
            message.error("Proof Is Required");
        }

    }

    updateDataForTripVoid = async () => {

        // console.log("first updateDataForTripVoid")
        this.formRef.current?.setFieldsValue({
            totalIncome: null,
            meterIncome: null,
            bookingCharge: null,
            driverTips: null,
            revenueKm: null,
            totalKm: null,
            trips: null,
            cashToReceive: null,
            cashTobereturned: null,
            suprchargeFuel: null,
            surchargeDriver: null,
            surchargeCompany: null
        });

        // console.log(this.state.shiftId, "697")
        const shiftData = await this.revenueCollectionStore.getDriverRevenueData(
            this.state.shiftId
        );

        // console.log(shiftData, "shiftData")
        const qrCodeData = await this.revenueCollectionStore.getPaymentQRData(this.state.shiftId)
        // console.log(qrCodeData, "qrCodeData 698")

        const totalIncomeData = {
            shiftFare: shiftData.shiftFare,
            shiftExtraFare: shiftData.shiftExtraFare
        }

        const totalIncome = this.calculateTotalIncome(totalIncomeData)
        // const totalIncome = revenueData.shiftFare + revenueData.shiftExtraFare

        const cashToReceiveData = {
            collectTotal: shiftData.collectTotal,
            discountCardTotalAmount: shiftData.discountCardTotalAmount,
            shiftCreditCardAmount: shiftData.shiftCreditCardAmount,
        }

        // console.log(shiftData.collectTotal, "shiftData.collectTotal")
        // console.log(shiftData.discountCardTotalAmount, "shiftData.discountCardTotalAmount")
        // console.log(shiftData.shiftCreditCardAmount, "shiftData.shiftCreditCardAmount")
        const cashToReceive = this.calculateCashToReceive(cashToReceiveData)

        const deductableExpense =
            Number(this.formRef.current?.getFieldValue("deductableExpense")) || 0;

        const finalCashToReceive = (
            cashToReceive - deductableExpense
        ).toFixed(2);


        console.log(cashToReceive, "cashToReceive")

        this.setState({
            cashToReceive: cashToReceive,
            originalCashToReceive: cashToReceive,
            loadData: 1
        })

        const ShiftHiredDistance = shiftData.shiftHiredDistance

        const meterIncome = shiftData.shiftFare - shiftData.shiftExtraFare


        const driverIncome = this.calculateDriverIncome(meterIncome, ShiftHiredDistance)

        this.formRef.current.setFieldsValue({
            totalIncome: totalIncome,
            companyIncome: (driverIncome.driverIncome).toFixed(2),
            meterIncome: meterIncome,
            bookingCharge: shiftData.shiftExtraFare,
            revenueAdjustment: shiftData.revenueAdjustment,
            // pendingAmount: shiftData.pendingAmount,
            driverTips: shiftData.tipsAmount,
            trips: shiftData.tripsQuantity,
            // creditCard: shiftData.shiftCreditCardAmount,
            cashToReceive: finalCashToReceive,
            totalKm: shiftData.shiftTotalDistance,
            revenueKm: shiftData.shiftHiredDistance,
            // cashCollection: shiftData.collectTotal,
            suprchargeFuel: (driverIncome.FuelSurchargeHirdKmTotal).toFixed(2),
            surchargeDriver: (driverIncome.DriverSurchargeHirdKmTotal).toFixed(2),
            surchargeCompany: (driverIncome.ITCSurchargeHirdKmTotal).toFixed(2),
            creditCard: qrCodeData.creditCard ?? 0.00,
            cashCollection: qrCodeData.cash ?? 0.00,
            qrcodecash: qrCodeData.qrCode ?? 0.00,
        })
    }

    render() {
        return (
            <>
                <div className="revenue-container">
                    <Form
                        ref={this.formRef}
                        layout="vertical"
                        onFinish={this.onRevenueDetailsSubmit}
                    >
                        {/* Driver Details */}
                        <Card
                            className="driver-card"
                            title={this.context.translate("_SELECT_DRIVER_")}
                        >
                            <Row gutter={[16, 16]}>
                                {/* Left Side */}
                                <Col xs={24} lg={12}>

                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="driverId"
                                                label={this.context.translate("_DRIVER_ID_")}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate("_DRIVER_ID_")} ${this.context.translate("_IS_REQUIRED_")}`,
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    className="selectDriver"
                                                    showSearch
                                                    placeholder={this.context.translate(
                                                        "_SELECT_DRIVER_"
                                                    )}
                                                    filterOption={(inputValue, option) => {
                                                        return (
                                                            option.children
                                                                .toLowerCase()
                                                                .indexOf(
                                                                    inputValue.toLowerCase()
                                                                ) >= 0
                                                        );
                                                    }}
                                                    value={this.state.driverId}
                                                    onSelect={async (val) => {
                                                        this.showSelectedDriverInfo(val)
                                                        this.setState({
                                                            shiftId: null,
                                                        });

                                                        this.formRef.current?.setFieldsValue({
                                                            shiftId: null,
                                                            totalIncome: null,
                                                            companyIncome: null,
                                                            taxiId: null,
                                                            shiftNo: null,
                                                            shiftStartTime: null,
                                                            shiftEndTime: null,
                                                            meterIncome: null,
                                                            bookingCharge: null,
                                                            revenueAdjustment: null,
                                                            suprchargeFuel: null,
                                                            surchargeCompany: null,
                                                            surchargeDriver: null,
                                                            driverTips: null,
                                                            trips: null,
                                                            totalKm: null,
                                                            revenueKm: null,
                                                            deductableExpense: null,
                                                            deductableReason: null,
                                                            cashCollection: null,
                                                            qrcodecash: null,
                                                            creditCard: null,
                                                            cashToReceive: null,
                                                            receivedCash: null,
                                                            cashTobereturned: null,
                                                        });

                                                        await this.revenueCollectionStore.setProofForExpense([]);

                                                        this.setState({
                                                            setProofForExpense: [],
                                                        });
                                                    }}
                                                >
                                                    {this.vehicleStore?.getDriverName?.map(
                                                        (driver) => {
                                                            return (
                                                                <Option
                                                                    key={driver.driverId}
                                                                    value={driver.driverId}
                                                                >
                                                                    {driver.name}
                                                                </Option>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="shiftId"
                                                label={this.context.translate("_SHIFT_NUMBER_")}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate("_DRIVER_ID_")} ${this.context.translate("_IS_REQUIRED_")}`,
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    className="selectDriver"
                                                    showSearch
                                                    placeholder={this.context.translate(
                                                        "_SELECT_SHIFT_"
                                                    )}
                                                    filterOption={(inputValue, option) => {
                                                        return (
                                                            option.children
                                                                .toLowerCase()
                                                                .indexOf(
                                                                    inputValue.toLowerCase()
                                                                ) >= 0
                                                        );
                                                    }}
                                                    value={this.state.shiftId}
                                                    onSelect={async (val) => {
                                                        this.setState({ shiftId: val })
                                                        this.showSelectedShiftInfo(val)

                                                        await this.revenueCollectionStore.setProofForExpense([]);

                                                        this.setState({
                                                            setProofForExpense: [],
                                                        });
                                                    }}
                                                >
                                                    {this.revenueCollectionStore?.shiftsData?.map(
                                                        (shift) => {
                                                            return (
                                                                <Option
                                                                    key={shift.id}
                                                                    value={shift.id}
                                                                >
                                                                    {shift.shiftNo}
                                                                </Option>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="totalIncome"
                                                label={
                                                    <span style={{ fontWeight: 600 }}>
                                                        {this.context.translate("_TOTAL_INCOME_")}
                                                    </span>
                                                }
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="companyIncome"
                                                label={
                                                    <span style={{ fontWeight: 600 }}>
                                                        {this.context.translate("_COMPANY_INCOME_")}
                                                    </span>
                                                }
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col
                                    xs={24}
                                    lg={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: 110,
                                            height: 130,
                                            border: "1px solid #000",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: "#fff",
                                        }}
                                    >
                                        {/* <Image
                                            preview={false}
                                            width="100%"
                                            height="100%"
                                            style={{ objectFit: "cover" }}
                                            src={
                                                this.state.driverPhoto
                                                    ? config.fleetURL + "/images/drivers/" + this.state.driverPhoto
                                                    : require("../assets/images/camera.png")
                                            }
                                        /> */}

                                        {this.state.driverPhoto ? (
                                            <Image
                                                preview={false}
                                                width="100%"
                                                height="100%"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                                src={config.fleetURL + "/images/drivers/" + this.state.driverPhoto}
                                            />
                                        ) : (
                                            <CameraOutlined style={{ fontSize: 50, color: "#999" }} />
                                        )}

                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        {/* Taxi Meter Information & Payment Details */}
                        <Row gutter={[24, 24]}>
                            <Col xs={24} md={12}>
                                <Card
                                    className="info-card"
                                    title={this.context.translate("_TAXI_METER_INFORMATION_")}
                                >
                                    <Row gutter={[16, 16]}>
                                        <Col xs={24} lg={12}>
                                            <Form.Item
                                                name="taxiId"
                                                label={this.context.translate("_TAXI_ID_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                            <Form.Item
                                                name="shiftNo"
                                                label={this.context.translate("_SHIFT_NUMBER_")}

                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                            <Row gutter={[16, 0]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        name="shiftStartTime"
                                                        label={this.context.translate("_SHIFT_START_TIME_")}
                                                    >
                                                        <Input disabled={true} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        name="shiftEndTime"
                                                        label={this.context.translate("_SHIFT_END_TIME_")}
                                                    >
                                                        <Input disabled={true} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>


                                            <Form.Item
                                                name="meterIncome"
                                                label={this.context.translate("_METER_INCOME_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                            <Form.Item
                                                name="bookingCharge"
                                                label={this.context.translate("_BOOKING_CHARGES_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                        </Col>
                                        <Col xs={24} lg={12}>


                                            <Form.Item
                                                name="revenueAdjustment"
                                                label={this.context.translate("_REVENUE_ADJUSTMENT_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                            {/* <Form.Item
                                                name="pendingAmount"
                                                label={this.context.translate("_PENDING_AMOUNT_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item> */}

                                            <Form.Item
                                                name="suprchargeFuel"
                                                label={this.context.translate("_SURCHARGE_FUEL_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                            <Row gutter={[16, 0]}>
                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        name="surchargeCompany"
                                                        label={this.context.translate("_SURCHARGE_COMPANY_")}
                                                    >
                                                        <Input disabled={true} />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} sm={12}>
                                                    <Form.Item
                                                        name="surchargeDriver"
                                                        label={this.context.translate("_SURCHARGE_DRIVER_")}
                                                    >
                                                        <Input disabled={true} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>

                                            <Form.Item
                                                name="driverTips"
                                                label={this.context.translate("_DRIVER_TIPS_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>

                                        </Col>



                                    </Row>
                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="trips"
                                                label={this.context.translate("_SHIFT_TRIP_COUNT_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="totalKm"
                                                label={this.context.translate("_TOTAL_KM_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={8}>
                                            <Form.Item
                                                name="revenueKm"
                                                label={this.context.translate("_REVENUE_KM_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>

                            <Col xs={24} md={12}>
                                <Card
                                    className="info-card"
                                    title={this.context.translate("_PAYMENT_DETAILS_")}
                                    extra={
                                        <Button
                                            type="primary"
                                            onClick={this.handleTripDetails}
                                            style={{
                                                height: 30,
                                                minWidth: 100,
                                            }}
                                        >
                                            Trip Details
                                        </Button>
                                    }
                                >

                                    <span
                                        style={{
                                            marginBottom: '5px',
                                            fontSize: '15px',
                                            fontWeight: 500
                                        }}
                                    >
                                        {this.context.translate("_DEDUCTABLE_EXPENSES_")}
                                    </span>
                                    <Row gutter={16}>
                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item
                                                name="deductableExpense"
                                                label={this.context.translate("_DEDUCTABLE_EXPENSES_")}
                                            >
                                                <Input onChange={this.handleDeductableExpenseChange} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={8}>
                                            <Form.Item
                                                name="deductableReason"
                                                label={this.context.translate("_REASON_")}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} sm={12} md={8}>
                                            <div style={{ maxHeight: 180, overflowY: "auto" }}>
                                                <Form.Item
                                                    label={this.context.translate(" ")}
                                                >
                                                    <Upload
                                                        fileList={this.revenueCollectionStore.expensePhotoFromDb.fileList}
                                                        name="setProofForExpense"
                                                        listType="picture"
                                                        customRequest={(options) => this.uploadMultipleProofs(options)}
                                                        onChange={this.getUploadMultipleTrip}
                                                        onRemove={this.handleRemoveExpenseImage}
                                                        multiple
                                                        accept=".jpg,.png"
                                                    // {...this.revenueCollectionStore.expensePhotoFromDb}

                                                    >
                                                        <Button className="imgupload" icon={<UploadOutlined />}>
                                                            {this.context.translate("_PROOF_")}
                                                        </Button>
                                                    </Upload>
                                                </Form.Item>
                                            </div>
                                        </Col>


                                    </Row>

                                    <span
                                        style={{
                                            marginBottom: '5px',
                                            fontSize: '15px',
                                            fontWeight: 500
                                        }}>
                                        {this.context.translate("_NON_CASH_INCOME_")}
                                    </span>
                                    <Row gutter={16}>
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="cashCollection"
                                                label={this.context.translate("_CASH_COLLECTION_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="qrcodecash"
                                                label={this.context.translate("_QR_CODE_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="creditCard"
                                                label={this.context.translate("_CREDIT_CARD_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    {/* <span style={{
                                        marginBottom: '5px',
                                        fontSize: '15px',
                                        fontWeight: 500
                                    }}>
                                        {this.context.translate("_NON_DEDUCTABLE_EXPENSE_")}
                                    </span>

                                    <Row gutter={16}>
                                        <Col xs={24} sm={12} md={6}>
                                            <Form.Item
                                                name="nonDeductableExpense1"
                                                label={this.context.translate("_NDE1_")}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <Form.Item
                                                name="nonDeductableExpense2"
                                                label={this.context.translate("_NDE2_")}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>

                                            <Form.Item
                                                name="petrol"
                                                label={this.context.translate("_PETROL_")}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <Form.Item
                                                name="cng"
                                                label={this.context.translate("_CNG_")}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    </Row> */}

                                    <Row gutter={16}>
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="cashToReceive"
                                                label={
                                                    <span style={{ fontWeight: "bold" }}>
                                                        {this.context.translate("_CASH_TO_RECEIVE_")}
                                                    </span>
                                                }
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="receivedCash"
                                                label={this.context.translate("_RECEIVED_")}
                                            >
                                                <Input onChange={(e) => this.handleReceivedCashChange(e)} />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                name="cashTobereturned"
                                                label={
                                                    <span style={{ fontWeight: "bold" }}>
                                                        {this.context.translate("_TO_BE_RETURN_")}
                                                    </span>
                                                }
                                            // label={this.context.translate("_TO_BE_RETURN_")}
                                            >
                                                <Input disabled={true} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="payment-footer">
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            disabled={
                                                this.state.isShiftOpen ||
                                                this.state.disableAccept ||
                                                this.state.receivedCash === null ||
                                                this.state.receivedCash === "" ||
                                                this.state.receivedCash === undefined
                                            }
                                        >
                                            {this.context.translate("_ACCEPT_")}
                                        </Button>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div >


                <Modal
                    // className="windowModal"
                    open={this.state.openTripsPopup}
                    footer={null}
                    closable={false}
                    width={1200}
                    maskClosable={true}
                    onCancel={() => this.setState({ openTripsPopup: false })}>
                    <div style={{ height: "75vh", }}>
                        <Table
                            // className="schoolDashboardTable"
                            columns={this.tripColumns}
                            dataSource={this.revenueCollectionStore.taxiTripsData}
                            pagination={false}
                            scroll={{ y: 360 }}
                        />

                    </div>
                </Modal>

                <Modal
                    title={
                        <div className="deleteModalTitle">
                            <span> {this.context.translate(`Please Confirm Voiding Trip ${this.state.isTripVoidData?.bookingId} ?`)}</span>
                            <CloseOutlined
                                style={{ cursor: "pointer", color: "white" }}
                                onClick={() => {
                                    this.setState({ openIsTripVoidPopup: false, tripVoidProof: null })
                                    this.tripformRef.current?.resetFields();
                                }}
                            />
                        </div>
                    }
                    open={this.state.openIsTripVoidPopup}
                    className="addDeptModal"
                    description="Add interval"
                    onOk={() => this.setState({ openIsTripVoidPopup: false })}
                    closable={false}
                    // onCancel={() => this.setState({ openIsTripVoidPopup: false })}
                    footer={false}
                    width={350}
                >
                    <Form
                        layout="vertical"
                        onFinish={this.handleTripUpdateSubmit}
                        style={{ maxWidth: "100%" }}
                        ref={this.tripformRef}
                    >
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: `${this.context.translate("_REASON_")} ${this.context.translate("_IS_REQUIRED_")}`,
                                },
                            ]}
                            name="reason"
                            label={this.context.translate("_REASON_")}
                        >
                            <Input />
                        </Form.Item>

                        <Upload
                            fileList={this.revenueCollectionStore.tripPhotoFromDb.fileList}
                            style={{ marginTop: '10px' }}
                            name="setProofForTripVoid"
                            listType="picture"
                            customRequest={(options) => this.uploadTripVoidProof(options)}
                            onChange={this.getUploadDataForTrip}
                            onRemove={async () => {
                                await this.revenueCollectionStore.setProofForTripVoid([]);
                                await this.setState({ setProofForTripVoid: null, });
                            }}
                            maxCount={1}
                            accept=".jpg,.png"
                        // {...this.revenueCollectionStore.tripPhotoFromDb}

                        >
                            <Button style={{ width: "180px", marginTop: '10px' }} className="imgupload" icon={<UploadOutlined />}>
                                {this.context.translate("_PROOF_")}
                            </Button>
                        </Upload>

                        <div className="addDeptModalButtons">
                            <Button
                                className="addDeptModalCancelButton"
                                onClick={() => this.setState({ openIsTripVoidPopup: false })}
                            >
                                {this.context.translate(
                                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                )}
                            </Button>
                            <Button
                                className="addDeptModalOkButton"
                                htmlType="submit"
                            >
                                {this.context.translate("_SUBMIT_")}
                            </Button>
                        </div>
                    </Form>

                </Modal>


                <Modal
                    title={
                        <div className="deleteModalTitle">
                            <span> {this.context.translate("_CHANGE_PAYMENT_METHOD_")}</span>
                            <CloseOutlined
                                style={{ cursor: "pointer", color: "white" }}
                                onClick={() => {
                                    this.setState({ openChangePaymentTypePopup: false });
                                    this.paymentformRef.current?.resetFields();
                                }}
                            />
                        </div>
                    }
                    open={this.state.openChangePaymentTypePopup}
                    className="addDeptModal"
                    description="Add interval"
                    onOk={() => this.setState({ openChangePaymentTypePopup: false })}
                    closable={false}
                    footer={false}
                    width={350}
                >

                    <Form
                        layout="vertical"
                        onFinish={this.handlePaymentTypeSubmit}
                        style={{ maxWidth: "100%" }}
                        ref={this.paymentformRef}
                    >
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: `${this.context.translate("_PAYMENT_TYPE_")} ${this.context.translate("_IS_REQUIRED_")}`,
                                },
                            ]}
                            label={this.context.translate("_PAYMENT_TYPE_")}
                            name="paymentType"
                            style={{ width: '100%' }}
                        >
                            <Select
                                onChange={(val) => this.setState({ selectPaymentType: val })}
                                showSearch
                            >
                                <Select.Option value={49}>Credit Card</Select.Option>
                                <Select.Option value={53}>QR Code</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: `${this.context.translate("_REASON_")} ${this.context.translate("_IS_REQUIRED_")}`,
                                },
                            ]}
                            name="reason"
                            label={this.context.translate("_REASON_")}
                        >
                            <Input />
                        </Form.Item>

                        <Upload
                            fileList={this.revenueCollectionStore.tripPhotoFromDb.fileList}
                            style={{ marginTop: '10px' }}
                            name="setProofForTripVoid"
                            listType="picture"
                            customRequest={(options) => this.uploadTripVoidProof(options)}
                            onChange={this.getUploadDataForTrip}
                            onRemove={async () => {
                                await this.revenueCollectionStore.setProofForTripVoid([]);
                                await this.setState({ setProofForTripVoid: null, });
                            }}
                            maxCount={1}
                            accept=".jpg,.png"
                        // {...this.revenueCollectionStore.tripPhotoFromDb}

                        >
                            <Button style={{ width: "180px", marginTop: '10px' }} className="imgupload" icon={<UploadOutlined />}>
                                {this.context.translate("_PROOF_")}
                            </Button>
                        </Upload>


                        <div className="addDeptModalButtons">
                            <Button
                                className="addDeptModalCancelButton"
                                onClick={() => this.setState({ openChangePaymentTypePopup: false })}
                            >
                                {this.context.translate(
                                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                )}
                            </Button>
                            <Button
                                className="addDeptModalOkButton"
                                htmlType="submit"
                            // loading={this.state.loading}
                            >
                                {this.context.translate("_SUBMIT_")}
                            </Button>
                        </div>
                    </Form>

                </Modal>


            </>)
    }
}

RevenueCollection.contextType = StoreContext;
export default observer(withRouter(RevenueCollection));